import moment from 'moment';
const UpdatedDate = ({ children }: { children: Date }) => {
  const updateDate = moment(children);
  return (
    <>
      {updateDate.isValid() && updateDate.year() > 2000
        ? updateDate.format('MMMM Do YYYY')
        : ''}
    </>
  );
};
export default UpdatedDate;
